import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import $ from 'jquery';
import common from './../../common';
import FormationLabel from './../onboarding/FormationLabel';
import JerseyManageTeam from './Jersey-ManageTeam';
import JerseyManageSubs from './Jersey-ManageTeam-Substitution';
import JerseyManagePoints from './Jersey-Manage-Team-Points';
import NextBtn from './../onboarding/NextBtn';
import config from "../../config";
import {
    openMobilePlayerListing,
    setManageTeamMode,
    triggerHandlePlayerCard,
    triggerShareTeam,
    triggerClearShareUrl,
    setPlayerRecomendationFirstTimeFalse,
    showHidePlayerRecomendationPopUp,
    showPlayerRecomMobPopUp
} from './../../actions/FormationActions';
import {
    resetTransfers,
} from './../../actions/ManageTeamActions';
import MoreMenu from './../../components/onboarding/MoreMenu';
import AutoCompleteTeam from './../../components/onboarding/AutoCompleteTeam';
import BoosterBtn from './../../components/onboarding/BoosterBtn';
import {
    getInTeamArray,
    getState
} from "../../helper";
import {
    isBoosterTaken,
} from "../../helper-booster";
import { isEmpty } from 'lodash';
import TeamShare from "../shareTeam/share-Team"
import ManageTeamStatus from './Manage-Team-Status';
import TopSectionHeader from './Top-Section-Header';
import { getStep } from '../../route-component';
import Fixture from './Fixture';
import MatchdayStatus from './Matchday-Status';
import routeObject from '../../constants/new-pageTrackEvents'

class PitchViewManageTeam extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showShare: false,
            showRecomendationPopUp: false
        };
    }

    animateView = (target) => {
        if (target.length === 0) return;
        const BUFFER = 30;
        const topValue = $(target).offset().top - ($('.si-transfers-strip').height() || 0) - ($('.si-actions-tooltip').outerHeight() || 0) - BUFFER;
        const { userSpecificFixtures, currentActiveFixture } = this.props;
        const currentFixture = userSpecificFixtures[(currentActiveFixture || 0)];
        let getViewState = "";
        if (currentFixture) {
            getViewState = getState(currentFixture);
        }


        if (getViewState === config.possibleActions["substitution"]) {
            //do nothing
        } else {
            $('html,body').animate({
                scrollTop: topValue
            }, 500);
        }

    };
    animateSelectedInView = () => {
        // const tooltipElem = $('.si-more-opts').closest('.si-plyr-wrap');
        // const elem = $('.si-current');
        // if (tooltipElem.length === 0 && elem.length) {
        //     this.animateView(elem);
        // }
        // let rowMapArr = [{ "0":}]/
        let self = this;
        const tooltipElem = $('.si-more-opts').closest('.si-plyr-wrap');
        // const elem = $('.si-current');
        // const elem = $(".si-container.si-pitch-sections .si-team-row").each(function () {
        //     return $(this).attr("rowid") == 4;
        // })

        let elem = "";
        $(".si-container .si-pitch-sections .si-team-row").each(function () {
            if ($(this).attr("rowid") == self.props.currentPosition.rowIndex) {
                elem = $(this);
            }

        })
        if (self.props.currentPosition.rowIndex == 0) {
            elem = $(".si-subs-wrap .si-team-row");
        }


        if (tooltipElem.length === 0 && elem.length) {
            this.animateView(elem);
        }
    };
    handleNext = (btnType) => {
        if (btnType === "substitution") {
            common.pageViewTracking("", routeObject["substitution"]);
        }

        if (btnType === "transfer") {
            common.pageViewTracking("", routeObject["transfer"]);
        }


        if (btnType == "playerlist") {
            common.customTracking('View Players - Pitch', '/uclfantasy/my-team/manage/');
            this.props.openMobilePlayerListing(true);
        } else {
            this.props.handleNext(btnType);
        }

    };

    componentDidMount() {
        // f0r tracking
        const getViewState = this.props['viewState'];
        const { manageTeamMode } = this.props;
        if (getViewState === config.possibleActions["live"]) {
            common.pageViewTracking("", routeObject["live"]);
        }

        if (manageTeamMode === config.modes["substitution"]) {
            common.pageViewTracking("", routeObject["substitution"]);
        }

        if (manageTeamMode === config.modes["transfer"]) {
            common.pageViewTracking("", routeObject["transfer"]);
        }
    }
    componentWillMount() {
        if (this.props.mobilePlayerListingOpen) {
            this.props.openMobilePlayerListing(false);
        }
        this.props.resetTransfers();
        this.props.setManageTeamMode(config.modes["view-manage-team"]);
    }

    componentDidUpdate(prevProps) {
        const { mobilePlayerListingOpen, currentPosition } = this.props;
        if ((mobilePlayerListingOpen !== prevProps.mobilePlayerListingOpen) && mobilePlayerListingOpen) {
            const elem = $('.si-plyr-list-wrap');
            if (mobilePlayerListingOpen) {
                elem.off().on('webkitTransitionEnd transitionend msTransitionEnd oTransitionEnd', () => {
                    this.animateSelectedInView();
                });
            } else {
                elem.off();
            }
        } else {
            if (config.isMobile) {
                const { playerIndex, rowIndex, skill } = currentPosition;
                if (playerIndex !== prevProps.playerIndex ||
                    rowIndex !== prevProps.rowIndex ||
                    skill !== prevProps.skill) {
                    // this.animateSelectedInView();
                }
            }
        }

    }

    toHideListInMobile = (e) => {
        if (!$(e.target).closest('.si-plyr-wrap').length) {
            this.props.openMobilePlayerListing(false);
        }
    };

    toShareTeam = (e) => {
        //form payload
        common.showLoader();

        const { userSpecificFixtures, currentActiveFixture } = this.props;
        const selectedMatchDay = userSpecificFixtures[currentActiveFixture].GDID || 0;
        const getViewState = this.props['viewState'];
        let sharePayload = {
            Guid: common.getGUID(),
            PhaseId: this.props.constraints.PhaseId ? this.props.constraints.PhaseId : "",
            GamedayId: selectedMatchDay,
            //points
            myPoints: getViewState === config.possibleActions["viewpoint"] ? 1 : 0,
            platformId: config.PLATFORM_ID,
            language: config.CURRENT_LANGUAGE
        }
        this.props.triggerShareTeam(sharePayload);
    }

    showPopUp = () => {

        common.customTracking('Select Player Recommendations Filter - Pitch', '/uclfantasy/my-team/transfers/');
        // show firsrt time pop up 
        if (this.props.IsFirstTimeRecomend) {
            //show Pop Up
            common.setLocalStorage('IsFirstTimeRecomend', false);
            this.props.setPlayerRecomendationFirstTimeFalse(false);
            this.props.showHidePlayerRecomendationPopUp(true);

        } else {
            //show drop down
            this.props.showPlayerRecomMobPopUp(true);
        }
        this.props.openMobilePlayerListing(true);
    }

    onShareTap = () => {
        this.props.triggerClearShareUrl()
    };

    render() {
        let { teamData, trans, triggerHandlePlayerCard } = this.props;
        const { liveScoringData, manageTeamMode, manageTeamRawData, userSpecificFixtures, currentActiveFixture, location } = this.props;
        const { IsAccounting, SubsNegativePoints, SubstitutionsLeft } = teamData;
        const getViewState = this.props['viewState'];
        const budget = teamData.budget;
        const keysToDisplay = ['4', '3', '2', '1'];
        const keysToTest = ['0', '1', '2', '3', '4'];
        let pitchView = [];
        let subView = null;
        const shallProceed = keysToTest.every((key) => {
            return teamData.hasOwnProperty(key);
        });
        if (shallProceed) {
            pitchView = shallProceed && keysToDisplay.map((keyIndex) => {
                const posArray = teamData[keyIndex];
                const numOfPlayers = posArray.length;
                const numOfPlayersInWords = common.numToWord(numOfPlayers);
                const classN = 'si-row-' + numOfPlayersInWords;
                const players = posArray.map((player, index) => {
                    if (getViewState === config.possibleActions["live"]) {
                        player = liveScoringData[keyIndex][index];
                    }
                    const isSecond = numOfPlayers > 3 && (index === 1);
                    const isSecondLast = numOfPlayers > 3 && (index === numOfPlayers - 2);
                    const isLast = index >= numOfPlayers / 2;
                    const isOdd = numOfPlayers % 2 !== 0;
                    const position = isSecond ? 'second' : isSecondLast ? 'second-last' : (isOdd && (Math.floor(numOfPlayers / 2) === index)) ? '' : isLast ? 'right' : 'left';
                    return ((getViewState === config.possibleActions["live"] || getViewState === config.possibleActions["viewpoint"]) ?
                        <JerseyManagePoints trans={ trans } player={ player } key={ index } index={ index }
                            viewState={ getViewState }
                            triggerHandlePlayerCard={ triggerHandlePlayerCard } /> :
                        (manageTeamMode === config.modes["substitution"]) ?
                            <JerseyManageSubs player={ player } key={ index } index={ index } objKey={ keyIndex }
                                position={ position } /> :
                            <JerseyManageTeam player={ player } key={ index } index={ index } objKey={ keyIndex }
                                position={ position } numOfPlayers={ numOfPlayers }
                                captainChangePopup={ this.props.captainChangePopup.bind(this) } />)
                });
                return <div className={ "si-team-row si-flexBox " + classN } rowid={ keyIndex } key={ keyIndex }>{ players }</div>
            });
            const benchArray = teamData['0'];
            const numOfPlayers = benchArray.length;
            const numOfPlayersInWords = common.numToWord(numOfPlayers);
            const classN = 'si-row-' + numOfPlayersInWords;
            let firstPlayedPlayerSubsOut = false;
            let players = benchArray.map((player, index) => {
                if (getViewState === config.possibleActions["live"]) {
                    player = liveScoringData['0'][index];
                }
                const { DBDetails, substituted } = player;
                let isSubsOut = (+DBDetails.BenchPosition === 0) && substituted && (+DBDetails.IsPlayed === 1);
                let showSubsOutTooltip = false;
                if (isSubsOut && !firstPlayedPlayerSubsOut) {
                    firstPlayedPlayerSubsOut = true;
                    showSubsOutTooltip = true;
                }
                player.showSubsOutTooltip = showSubsOutTooltip;
                const isSecond = numOfPlayers > 3 && (index === 1);
                const isSecondLast = numOfPlayers > 3 && (index === numOfPlayers - 2);
                const isLast = index >= numOfPlayers / 2;
                const isOdd = numOfPlayers % 2 !== 0;
                const position = isSecond ? 'second' : isSecondLast ? 'second-last' : (isOdd && (Math.floor(numOfPlayers / 2) === index)) ? '' : isLast ? 'right' : 'left';
                return ((getViewState === config.possibleActions["live"] || getViewState === config.possibleActions["viewpoint"]) ?
                    <JerseyManagePoints trans={ trans } player={ player } key={ index } index={ index } viewState={ getViewState }
                        triggerHandlePlayerCard={ triggerHandlePlayerCard } /> :
                    (manageTeamMode === config.modes["substitution"]) ?
                        <JerseyManageSubs player={ player } key={ index } index={ index } objKey={ 0 } position={ position } /> :
                        <JerseyManageTeam player={ player } key={ index } index={ index } objKey={ 0 } position={ position }
                            numOfPlayers={ numOfPlayers } captainChangePopup={ this.props.captainChangePopup.bind(this) } />)
            });
            subView = <div className={ "si-team-row si-flexBox " + classN } >{ players }</div>
        }
        const handler = (config.isMobile && this.props.mobilePlayerListingOpen) ? { onClick: (e) => this.toHideListInMobile(e) } : {};

        const shareHandler = { onClick: (e) => this.toShareTeam(e) };

        let showNextBtn = false;
        let showTransferBtn = false;
        let showSubstitutionBtn = false;
        let showSubsConfirmButtons = false;
        let showSubsCancelButtons = false;
        let showActionBtn = false;
        let showFormationLbl = false;
        let showShareBtn = false;


        if (manageTeamMode === config.modes["view-manage-team"]) {

            if (!(getViewState === config.possibleActions["live"] || getViewState === config.possibleActions["viewpoint"])) {
                showFormationLbl = true;
                showShareBtn = true
            }

            if (getViewState === config.possibleActions["viewpoint"]) {
                showShareBtn = true
            }

            if (getViewState) {
                if (getViewState === config.possibleActions["substitution"]) {
                    showActionBtn = true;
                    showSubstitutionBtn = true;
                    showShareBtn = false;

                } else if (getViewState === config.possibleActions["transfer"] || getViewState === config.possibleActions["subsAndTransfer"]) {
                    showActionBtn = true;
                    showTransferBtn = true;
                    showShareBtn = true
                }
            }
        } else if (manageTeamMode === config.modes["substitution"]) {

            showActionBtn = true;
            showSubsConfirmButtons = true;
            showSubsCancelButtons = true;
            showShareBtn = true
        } else if (manageTeamMode === config.modes["transfer"]) {

            showActionBtn = true;
            showNextBtn = true;
            showShareBtn = true
        }
        const isTransfersStripVisible = manageTeamMode === config.modes["transfer"];
        let buttonTypes = null;
        let nextBtnProps = {};
        let cancelBtnProps = {};
        let btnWrapClass = common.makeClasses({
            'si-btn-wrp': this.props.playerRecomendation ? false : true,
            // 'si-subs-mode-btn': (manageTeamMode === config.modes["substitution"])
        });
        if (showTransferBtn) {
            nextBtnProps = {
                isDisabled: this.props.isDisabled,
                showTitle: this.props.isDisabled,
                tooltipText: this.props.trans.transfer,
                showIcon: true,
                isTransferBtn: true,
                iconClass: 'icon-ucl-transfers',
                text: this.props.trans.transfer,
                handler: () => this.handleNext("transfer"),
            }
        } else if (showSubstitutionBtn) {
            nextBtnProps = {
                isDisabled: this.props.isDisabled,
                showTitle: this.props.isDisabled,
                tooltipText: this.props.trans.makeSubstitutions,
                showIcon: true,
                isSubsBtn: true,
                iconClass: 'icon-ucl-subsitute',
                text: this.props.trans.substitutePc,
                handler: () => this.handleNext("substitute"),
            }
        } else if (showSubsConfirmButtons && showSubsCancelButtons) {
            // cancelBtnProps = {
            //     isDisabled: false,
            //     showTitle: this.props.isDisabled,
            //     tooltipText: this.props.trans.cancel,
            //     isNoBorder: true,
            //     text: this.props.trans.cancel,
            //     handler: () => this.handleNext("cancel"),
            // };
            nextBtnProps = {
                isDisabled: this.props.isDisabled,
                showTitle: this.props.isDisabled,
                tooltipText: this.props.trans.confirm,
                text: this.props.trans.confirm,
                handler: () => this.handleNext("confirm"),
            }
        } else if (showNextBtn) {
            if (this.props.isDisabled) {
                nextBtnProps = {
                    isDisabled: false,
                    showTitle: this.props.isDisabled,
                    tooltipText: this.props.trans.next,
                    text: this.props.trans.viewplayer ? this.props.trans.viewplayer : "View Players",
                    handler: () => this.handleNext("playerlist"),
                }
            } else {
                nextBtnProps = {
                    isDisabled: this.props.isDisabled,
                    showTitle: this.props.isDisabled,
                    tooltipText: this.props.trans.next,
                    text: this.props.trans.next,
                    handler: () => this.handleNext("next"),
                }
            }


        }
        if (showActionBtn) {
            buttonTypes = <div className={ btnWrapClass }>
                { showSubsCancelButtons && !isEmpty(cancelBtnProps) ? <NextBtn { ...cancelBtnProps } /> : null }
                <NextBtn { ...nextBtnProps } />
            </div>;
        }
        let si_val = '';
        let boosterTaken = false;
        let limitlessBudget = false;
        let transferredIn = [];
        let hideAutocomplete = false;
        let isDisabled = (teamData.playerCount < config.MAX_PLAYERS_PER_TEAM) || (budget < 0);
        if (manageTeamMode === config.modes["transfer"]) {
            transferredIn = getInTeamArray(teamData, manageTeamRawData);
            let isWildCardSelected = isBoosterTaken('IsWildCardTaken', teamData, userSpecificFixtures, currentActiveFixture);
            let isLimitlessSelected = isBoosterTaken('IsBoosterOneTaken', teamData, userSpecificFixtures, currentActiveFixture);
            boosterTaken = (isWildCardSelected || isLimitlessSelected);
            const budgetRestriction = isLimitlessSelected ? false : (budget < 0);
            hideAutocomplete = isLimitlessSelected;
            limitlessBudget = isLimitlessSelected;
            isDisabled = (transferredIn.length <= 0) || (budgetRestriction) || (teamData.playerCount < config.MAX_PLAYERS_PER_TEAM);
        }
        const IsBudgetExceeded = budget < 0;
        const budgetWrapperClasses = common.makeClasses({
            'si-budget-wrap': true,
            'si-error': IsBudgetExceeded && !limitlessBudget
        });
        if (+IsAccounting === 0 || boosterTaken) {
            si_val = <div className="si-val">
                <div className="si-infinity-icon">∞</div>
                <span className="si-txt"> { this.props.trans.free }</span>
            </div>
        } else if (+IsAccounting === 1) {
            const subsLeft = transferredIn.length > 0 ? (SubstitutionsLeft - transferredIn.length) : SubstitutionsLeft;
            if (subsLeft < 0) {
                const negativePoints = (SubsNegativePoints * subsLeft);
                si_val = <div className="si-val" style={ { 'color': 'red' } }>
                    <span className="si-count">{ negativePoints }</span>
                    <span className="si-txt"> { this.props.trans.labelPts }</span>
                </div>
            } else {
                si_val = <div className="si-val">
                    <span className="si-count">{ subsLeft }</span>
                    <span className="si-txt"> { this.props.trans.free }</span>
                </div>
            }
        }
        return <div className="si-pitch-view-wrap">
            {
                (manageTeamMode === config.modes["transfer"])
                    ?
                    <div className="si-top-section si-web">
                        <ManageTeamStatus
                            handleNext={ this.handleNext.bind(this) } { ...{ isDisabled } } { ...{ hideAutocomplete } } />
                    </div>
                    :
                    null
            }
            { isTransfersStripVisible ? <div className="si-transfers-strip si-flexBox">
                <div className="si-flexBox si-section-one">
                    <div className="si-transfers-count">
                        <span className="si-title">{ this.props.trans.transfers }</span>
                        { si_val }
                        <div className="si-tooltip si-budget-tooltip">
                            <span className="si-title">{ this.props.trans.budget_exceeded }</span>
                            <span className="si-text">{ this.props.trans.budgetWarning }</span>
                        </div>
                    </div>
                    <div className={ budgetWrapperClasses }>
                        <span className="si-title">{ this.props.trans.budget }</span>
                        {
                            limitlessBudget ?
                                <div className="si-val">
                                    <div className="si-infinity-icon">∞</div>
                                </div> :
                                <div className="si-val">
                                    <span>€</span>
                                    <span className="">{ budget }</span>
                                    <span>{ this.props.trans.million }</span>
                                </div>
                        }
                    </div>
                </div>
                <div className="si-flexBox si-section-two">
                    <div className="si-booster-wrap">
                        <BoosterBtn />
                    </div>
                    <div className="si-common-menu">
                        { !limitlessBudget ? <AutoCompleteTeam /> : null }
                        <MoreMenu />
                    </div>
                </div>
            </div> : null }
            <div className="si-container si-pitch-sections"  { ...handler }>
                { pitchView }
                { (showFormationLbl && (config.isMobile ? !this.props.mobilePlayerListingOpen : true)) ?
                    <FormationLabel /> : null }
                { (showShareBtn) ? <div className="si-share-team-icon" { ...shareHandler }><i className="icon-ucl-share" /></div> : null }
            </div>
            <div className="si-subs-wrap">
                <div className="si-container">
                    { subView }
                </div>
            </div>

            <div className="si-btn-wrp si-dual-btn">
                { buttonTypes }
                { this.props.playerRecomendation && isTransfersStripVisible && this.props.isDisabled ? <div className="si-suggest-box" onClick={ () => { this.showPopUp() } }>
                    <i className="icon-ucl-new-filter"></i>
                    { this.props.IsFirstTimeRecomend ? <span className="si-suggest-new si-flexBox">{ this.props.trans.new ? this.props.trans.new : "new" }</span> : null }
                </div> : null }
            </div>

            { this.props.shareUrl ? <TeamShare ShareLoad={ this.props.shareUrl } trans={ trans } toHide={ this.onShareTap.bind(this) } /> : null }
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        teamData: state.formationData.teamData,
        mobilePlayerListingOpen: state.formationData.mobilePlayerListingOpen,
        currentPosition: state.formationData.currentPosition,
        manageTeamMode: state.formationData.manageTeamMode,
        userSpecificFixtures: state.formationData.userSpecificFixtures,
        currentActiveFixture: state.formationData.currentActiveFixture,
        manageTeamRawData: state.formationData.manageTeamRawData,
        constraints: state.appData.constraints,
        shareUrl: state.formationData.shareUrl,
        playerRecomendation: state.formationData.playerRecomendation,
        IsFirstTimeRecomend: state.formationData.IsFirstTimeRecomend,
        userSpecificFixtures: state.formationData.userSpecificFixtures,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        openMobilePlayerListing: (bool) => dispatch(openMobilePlayerListing(bool)),
        setManageTeamMode: (mode) => dispatch(setManageTeamMode(mode)),
        resetTransfers: () => dispatch(resetTransfers()),
        getInTeamArray: (teamData, oldTeamData) => dispatch(getInTeamArray(teamData, oldTeamData)),
        triggerHandlePlayerCard: (isPlayerCardVisible, playerObj) => dispatch(triggerHandlePlayerCard(isPlayerCardVisible, playerObj)),
        triggerShareTeam: (sharePayload) => dispatch(triggerShareTeam(sharePayload)),
        triggerClearShareUrl: () => dispatch(triggerClearShareUrl()),
        setPlayerRecomendationFirstTimeFalse: () => dispatch(setPlayerRecomendationFirstTimeFalse()),
        showHidePlayerRecomendationPopUp: (bool) => dispatch(showHidePlayerRecomendationPopUp(bool)),
        showPlayerRecomMobPopUp: (bool) => dispatch(showPlayerRecomMobPopUp(bool))
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PitchViewManageTeam));


// WEBPACK FOOTER //
// ./src/components/manage-team/PitchView-ManageTeam.js